import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";
import { PRD2010_R01Dto } from "./Dto_PRD2010_R01";
import { PRD2010_R01Filter, Store_PRD2010_R01 } from "./Store_PRD2010_R01";
import { formatDate } from "src/utils/string/stringUtil";

const baseUrl = `${config.apiUrl}/PRD2010_R01`;

const getParams = (filter: Partial<PRD2010_R01Filter>, listLength?: number) => {
	return {
		compCd: filter.compCd,
		workplaceCd: filter.workplaceCd,
		jobTeam: filter.jobTeam,
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		closeTag: filter.closeTag,
		listLength: listLength || 0
	}
}

export const getPRD2010_R01List = async (option: string, params: Partial<PRD2010_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/${option}`

    return await getData<ResponseDto<PRD2010_R01Dto[]>>(url, { params: getParams(params, listLength) });
}

export const getPRD2010_R01AllCount = async (params: Partial<PRD2010_R01Filter>) => {
    const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, { params: getParams(params, 0) });
}

export const postPRD2010_R01 = async (data: PRD2010_R01Dto[]) => {
    const url = `${baseUrl}`;

    return await postData<PRD2010_R01Dto[], ResponseDto<PRD2010_R01Dto[]>>(url, data);
}

export const postPRD2010_R01More = async (data: PRD2010_R01Dto[]) => {
    const url = `${baseUrl}/more`;

    return await postData<PRD2010_R01Dto[], ResponseDto<PRD2010_R01Dto[]>>(url, data);
}

export const patchPRD2010_R01 = async (data: PRD2010_R01Dto[]) => {
    const url = `${baseUrl}`;

    return await patchData<PRD2010_R01Dto[], ResponseDto<PRD2010_R01Dto[]>>(url, data);
}

export const deletePRD2010_R01 = async (userId: string) => {
    let url = `${baseUrl}/${userId}`;

    return await deleteData<ResponseDto<any>>(url);
}

export const downloadExcel_PRD2010_R01 = async (option: string, params: Partial<PRD2010_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/excel/${option}`

    return await getData<ResponseDto<string>>(url, { params: getParams(params, listLength) });
}

export const getPdfBlob_PRD2010_R01 = async (productOrderNo: string): Promise<Blob> => {
	const url = `${baseUrl}/print`;
	const response = await getData<Blob>(url, {
		params: { productOrderNo },
		responseType: "blob",
	});
	return new Blob([response.data], { type: "application/pdf" });
};